// Английски превод — roles. Ключ = българският текст от кода.
export const EN_ROLES: Record<string, string> = {
  // --- общи ---
  'Зареждане…': 'Loading…',
  'Изпрати': 'Send',
  'Копирай': 'Copy',
  'Копирано.': 'Copied.',
  'Описание': 'Description',
  'Нередности': 'Issues',
  'Наемател': 'Tenant',
  'Наемодател': 'Landlord',
  'Наем': 'Rent',
  'Телефон': 'Phone',
  'От': 'From',
  'До': 'To',
  'Причина: {reason}': 'Reason: {reason}',
  'от {date}': 'from {date}',
  'от {name}': 'by {name}',
  '{amount}/мес.': '{amount}/mo.',
  'Затворено': 'Closed',
  'Чернова': 'Draft',
  'Отхвърлена': 'Rejected',
  'Редактирай': 'Edit',
  'Фактура № {number}': 'Invoice No. {number}',

  // --- етикети от api.ts (UTILITY_LABELS, ISSUE_STATUS_LABELS, PAYMENT_STATUS_LABELS),
  // минават през t() при показване ---
  'Ток': 'Electricity',
  'Вода': 'Water',
  'Такса вход': 'Building fee',
  'Газ': 'Gas',
  'Интернет': 'Internet',
  'Друго': 'Other',
  'Подадена': 'Submitted',
  'Видяна': 'Seen',
  'Възложена': 'Assigned',
  'Отстранена': 'Resolved',
  'Потвърдена': 'Confirmed',
  'Дължимо': 'Due',
  'Чака потвърждение': 'Awaiting confirmation',
  'Наредено': 'Submitted',
  'Изтеглено': 'Collected',
  'Пътува': 'In transit',
  'Платено': 'Paid',
  'Неуспешно': 'Failed',
  'Върнато': 'Returned',
  'Отпаднало (прекратен наем)': 'Cancelled (tenancy ended)',
  'Получено': 'Received',

  // --- DocumentsScreen (DOCUMENT_TYPE_LABELS) ---
  'Договор': 'Contract',
  'Фактура': 'Invoice',
  'Бележка за плащане': 'Payment receipt',
  'Разписка за депозит': 'Deposit receipt',
  'Предизвестие': 'Notice',
  'Протокол': 'Protocol',
  'Документ': 'Document',
  'Документът е изпратен към наемателя.': 'The document has been sent to the tenant.',
  'Документи': 'Documents',
  'Празна бланка на договора за наем — всички полета с многоточия, за попълване на ръка.': 'Blank rental contract form — all fields dotted, to be filled in by hand.',
  'Изтегли празен договор (PDF)': 'Download blank contract (PDF)',
  'Още няма документи. Генерирайте договор, фактура или разписка от екрана на имота.': 'No documents yet. Generate a contract, invoice or receipt from the property screen.',
  'Още няма документи. Тук ще виждате изпратените от наемодателя + автоматичните бележки и протоколи.': 'No documents yet. Here you will see documents sent by the landlord plus automatic receipts and protocols.',
  'Отвори (PDF)': 'Open (PDF)',
  'Изпратен ✓ ({date})': 'Sent ✓ ({date})',
  'Изпрати на наемателя': 'Send to tenant',

  // --- InvoicesScreen (KIND_LABELS) ---
  'Кредитно известие': 'Credit note',
  'Дебитно известие': 'Debit note',
  'Фактурата е изпратена на наемателя.': 'The invoice has been sent to the tenant.',
  'Анулиране': 'Cancellation',
  'Анулиране на фактура № {number}? Не може да се редактира — само анулира.': 'Cancel invoice No. {number}? It cannot be edited — only cancelled.',
  'Анулирай': 'Cancel invoice',
  'Фактурата е анулирана.': 'The invoice has been cancelled.',
  'Фактури': 'Invoices',
  'Изтегли CSV за счетоводител': 'Download CSV for accountant',
  'Още няма издадени фактури. Издайте от екрана на имота.': 'No invoices issued yet. Issue one from the property screen.',
  'Няма получени фактури.': 'No invoices received.',
  '{kind} № {number}': '{kind} No. {number}',
  'АНУЛИРАНА': 'CANCELLED',
  'Изпратена на наемателя на {date}': 'Sent to the tenant on {date}',
  'Редактирай (анулира и преиздава)': 'Edit (cancels and reissues)',
  'Коригирай (кредитно/дебитно известие)': 'Correct (credit/debit note)',

  // --- IssuesScreen ---
  'Доверен майстор': 'Trusted handyman',
  'Да изпратим ли заявката директно на {name}? Без оферта и без плащане през приложението — разплащането е по ваша лична уговорка.': 'Send the request directly to {name}? No offer and no payment through the app — payment is by your own arrangement.',
  'Заявката е изпратена на доверения майстор.': 'The request has been sent to the trusted handyman.',
  '+ Подай нередност': '+ Report an issue',
  'Няма нередности.': 'No issues.',
  'Чака вашето потвърждение': 'Awaiting your confirmation',
  'Чака наемателя': 'Waiting for the tenant',
  'Чака наемодателя': 'Waiting for the landlord',
  'Маркирай като видяна': 'Mark as seen',
  '⭐ Прати на {name} (безплатно)': '⭐ Send to {name} (free)',
  'Потърси друг майстор →': 'Find another handyman →',
  'Потърси майстор →': 'Find a handyman →',
  'Отстраних я сам': 'I fixed it myself',
  'Потвърждавам — отстранена е': 'I confirm — it is resolved',
  '⭐ Доверен майстор — без плащане през приложението': '⭐ Trusted handyman — no payment through the app',
  'Чака майсторът да приеме…': 'Waiting for the handyman to accept…',
  'Прие заявката — предстои ремонтът.': 'Request accepted — the repair is pending.',
  'Потвърждения: наемодател {a} · наемател {b}': 'Confirmations: landlord {a} · tenant {b}',
  'Потвърждение: наемодател {a} (без наемател)': 'Confirmation: landlord {a} (no tenant)',
  'Потвърждавам ремонта ✓': 'I confirm the repair ✓',
  'Потвърдено от двете страни ✓': 'Confirmed by both parties ✓',
  'Оцени майстора ★': 'Rate the handyman ★',
  'Чака оферта…': 'Awaiting an offer…',
  'Оферта: {price} · срок {days} дни': 'Offer: {price} · {days} days',
  'Приеми офертата': 'Accept offer',
  'Откажи': 'Decline',
  'Задържани: {amount}': 'Held: {amount}',
  'Чака изпълнение от майстора': 'Waiting for the handyman to complete',
  'Проблем с ремонта (спор)': 'Problem with the repair (dispute)',
  'Платено на майстора ✓': 'Paid to the handyman ✓',
  'В спор — при модератор': 'In dispute — with a moderator',
  'Парите са върнати': 'The money has been refunded',

  // --- ListingsScreen ---
  'Чака одобрение': 'Pending approval',
  'Публикувана ✓': 'Published ✓',
  'Архивирана': 'Archived',
  'Без снимки': 'No photos',
  '📸 Обявите със снимки получават повече запитвания — добавете снимки.': '📸 Listings with photos get more enquiries — add photos.',
  'Всички области': 'All regions',
  'Всички квартали': 'All districts',
  'Свободни апартаменти': 'Available apartments',
  'Всички обяви': 'All listings',
  'Моите обяви': 'My listings',
  'Област': 'Region',
  'Всички населени места': 'All settlements',
  'Квартал': 'District',
  'Макс. цена (€)': 'Max. price (€)',
  'Мин. стаи': 'Min. rooms',
  'Нямате обяви. Публикувайте от екрана на имота.': 'You have no listings. Publish one from the property screen.',
  'Няма обяви по тези критерии.': 'No listings match these criteria.',
  '{n} стаи': '{n} rooms',
  'Свържи се 💬': 'Get in touch 💬',
  'Свали обявата': 'Take down listing',
  'Публикувай пак': 'Publish again',

  // --- ConversationsScreen / ChatScreen ---
  'Съобщения': 'Messages',
  'Няма разговори. Те започват от обявите в „Свободни апартаменти“.': 'No conversations. They start from the listings in "Available apartments".',
  'С: {name}': 'With: {name}',
  'Разговор': 'Conversation',
  'Напишете първото съобщение — другата страна ще получи известие.': 'Write the first message — the other party will be notified.',
  'Съобщение…': 'Message…',

  // --- ReviewScreen ---
  'Благодарим! Ревюто е записано.': 'Thank you! The review has been saved.',
  'Оценка': 'Rating',
  'Оценявате: {name}': 'You are rating: {name}',
  'Колко звезди?': 'How many stars?',
  'Коментар (по избор)': 'Comment (optional)',
  'Разкажете накратко за опита си…': 'Briefly describe your experience…',
  'Запази оценката': 'Save rating',

  // --- ReputationScreen ---
  '1 месец': '1 month',
  '{n} месеца': '{n} months',
  '{n} дни': '{n} days',
  'няма ревюта': 'no reviews',
  'Провери наемател': 'Check a tenant',
  'Наемател, наемодател, пропърти мениджър или майстор — по телефон или име.': 'Tenant, landlord, property manager or handyman — by phone or name.',
  'Георги не е един. Ето какво щеше да види следващият му наемодател, преди да му даде ключовете:': 'There is more than one Georgi. Here is what his next landlord would have seen before handing over the keys:',
  'Пример — така изглежда проверка в Livupp': 'Example — this is what a Livupp check looks like',
  'Наемател · +359 88 4•• •••': 'Tenant · +359 88 4•• •••',
  'Неплатен наем — 2 наемодатели': 'Unpaid rent — 2 landlords',
  'Щети по имота': 'Property damage',
  '„Изчезна с два наема и остави апартамента в лошо състояние.“ — наемодател, Пловдив': '"Disappeared owing two months of rent and left the apartment in poor condition." — landlord, Plovdiv',
  'Отзивите пишат реални наемодатели. Виждат се безплатно след регистрация.': 'Reviews are written by real landlords. They are free to view after registration.',
  'проверки тази седмица': 'checks this week',
  'отзива от 1 наемодател': 'reviews from 1 landlord',
  'отзива от {n} наемодатели': 'reviews from {n} landlords',
  'Имали сте свой „Георги“?': 'Had a "Georgi" of your own?',
  'Добавете го за 1 минута — така следващият наемодател ще знае навреме.': 'Add them in 1 minute — so the next landlord knows in time.',
  'Добави наемател — безплатно': 'Add a tenant — free',
  '🔒 Отзиви само от потвърдени по телефон наемодатели · без имена и адреси, само оценка към номер · наемателят вижда отзивите за себе си и може да отговори.': '🔒 Reviews only from phone-verified landlords · no names or addresses, just a rating linked to a number · the tenant can see their reviews and reply.',
  '🎁 Първите {n} регистрирани — {period} безплатно · остават {left} места': '🎁 First {n} to register — {period} free · {left} places left',
  'Вече имате акаунт? Вход': 'Already have an account? Log in',
  'Или проверете номер сега': 'Or check a number now',
  '+359… или име': '+359… or name',
  'Търси': 'Search',
  'Виж повече за Livupp →': 'Learn more about Livupp →',
  'Още няма отзиви за този номер.': 'No reviews for this number yet.',
  'Няма намерен човек с това търсене.': 'No one found for this search.',
  'Имали сте проблем с този наемател? Регистрирайте се безплатно и оставете първия отзив — така предупреждавате следващия наемодател.': 'Had a problem with this tenant? Register for free and leave the first review — that way you warn the next landlord.',
  'Добави отзив — безплатно': 'Add a review — free',
  'Има отзиви за този човек.': 'There are reviews for this person.',
  'Този човек е в Livupp.': 'This person is on Livupp.',
  'Регистрирайте се безплатно (1 минута), за да видите оценката и какво пишат наемодателите — или да добавите свой отзив.': 'Register for free (1 minute) to see the rating and what landlords write — or add your own review.',
  'Виж отзивите — безплатно': 'See the reviews — free',
  'Искам да добавя отзив за този наемател →': 'I want to add a review for this tenant →',
  'Съществува като {role}': 'Exists as {role}',
  '{n} ревюта': '{n} reviews',
  'Има оставено ревю': 'Has a review',
  'Няма ревюта': 'No reviews',
  'Докоснете за пълните ревюта →': 'Tap for full reviews →',
  'Влезте, за да видите оценката и какво пишат ревютата.': 'Log in to see the rating and what the reviews say.',
  'Влезте, за да видите пълния профил.': 'Log in to see the full profile.',
  '← Обратно към резултатите': '← Back to results',
  'Среден рейтинг': 'Average rating',
  'Брой ревюта': 'Number of reviews',
  'Квартири': 'Homes',
  '{n} мес.': '{n} mo.',
  '(в момента)': '(currently)',
  'Още няма ревюта за този човек.': 'No reviews for this person yet.',
  '(без коментар)': '(no comment)',

  // --- tenant/NewIssueScreen ---
  'Заявката за ремонт е записана.': 'The repair request has been saved.',
  'Наемодателят получи известие за нередността.': 'The landlord has been notified about the issue.',
  'Ремонт / нередност': 'Repair / issue',
  'Нова нередност': 'New issue',
  'За кое жилище': 'Which home',
  'Изберете жилище': 'Select a home',
  'Заглавие (по избор)': 'Title (optional)',
  'Течащ кран': 'Leaking tap',
  'Опишете проблема възможно най-точно…': 'Describe the problem as precisely as possible…',
  'Снимки ({n})': 'Photos ({n})',
  '+ Добави снимка': '+ Add photo',
  'Ще можете да възложите ремонта на майстор и да потвърдите извършването му.': 'You will be able to assign the repair to a handyman and confirm its completion.',
  'Ще следите статуса: подадена → видяна → възложена → отстранена → потвърдена.': 'You will track the status: submitted → seen → assigned → resolved → confirmed.',

  // --- tenant/TenantHomeScreen ---
  'Кодът е открит в платежното. Наемодателят е известен.': 'The code was found on the payment slip. The landlord has been notified.',
  'Не откриваме кода {code} в основанието. Ако сте го пропуснали, плащането пак ще стигне, но наемодателят ще го засича по-трудно.': 'We could not find the code {code} in the payment reference. If you left it out, the payment will still arrive, but the landlord will have a harder time matching it.',
  'Отбелязано. Наемодателят ще провери сметката си и ще потвърди.': 'Noted. The landlord will check their account and confirm.',
  'Преведохте ли вече?': 'Have you already transferred?',
  '📸 Със снимка наемодателят вижда веднага, че кодът е вписан, и потвърждава по-бързо.': '📸 With a photo the landlord sees right away that the code is included and confirms faster.',
  'Платих — прилагам снимка': 'I paid — attaching a photo',
  'Снимай платежното 📷': 'Photograph the payment slip 📷',
  'Продължи без снимка': 'Continue without a photo',
  'Наредено — чака потвърждение от наемодателя': 'Transferred — awaiting confirmation from the landlord',
  'Кодът е открит в платежното ✓': 'Code found on the payment slip ✓',
  'Кодът не е открит в платежното': 'Code not found on the payment slip',
  'Ако сте го пропуснали, плащането пак ще стигне, но наемодателят ще го засича по-трудно.': 'If you left it out, the payment will still arrive, but the landlord will have a harder time matching it.',
  'Качи друга снимка': 'Upload another photo',
  '⚠️ В платежното е {a}, а дължимото е {b}.': '⚠️ The payment slip shows {a}, but the amount due is {b}.',
  'Без приложено платежно. Можете да добавите снимката и сега.': 'No payment slip attached. You can add the photo now.',
  'Добави снимка на платежното': 'Add a photo of the payment slip',
  'Здравейте!': 'Hello!',
  'В момента нямате активно наемно отношение. Акаунтът ви се запазва — когато наемодател добави номера ви, новият дом ще се появи тук автоматично.': 'You currently have no active tenancy. Your account is kept — when a landlord adds your number, your new home will appear here automatically.',
  'Предишни квартири': 'Previous homes',
  'Оцени наемодателя ★': 'Rate the landlord ★',
  'Историята ви е видима за бъдещи наемодатели и работи във ваша полза.': 'Your history is visible to future landlords and works in your favour.',
  'Архивът ви остава достъпен': 'Your archive stays available',
  'Договори, бележки за платен наем и протоколи от предишни квартири.': 'Contracts, rent receipts and protocols from previous homes.',
  'Моите документи →': 'My documents →',
  'Потвърдихте протокола.': 'You confirmed the protocol.',
  '{label} е копиран.': '{label} copied.',
  'Съгласието е подписано. Наемът ще се тегли автоматично.': 'The mandate has been signed. Rent will be collected automatically.',
  'Моят дом': 'My home',
  'Отстранена нередност чака потвърждение': 'A resolved issue is awaiting confirmation',
  'Отстранени нередности чакат потвърждение': 'Resolved issues are awaiting confirmation',
  'Прегледайте резултата и потвърдете →': 'Review the result and confirm →',
  '⚠ Наемодателят не си е платил абонамента': '⚠ The landlord has not paid their subscription',
  '● Дължим наем · {month}': '● Rent due · {month}',
  'до {date}': 'by {date}',
  'Кодът за основание': 'The reference code',
  'ОСНОВАНИЕ ЗА ПРЕВОДА': 'TRANSFER REFERENCE',
  'Няма дължим наем — всичко е платено.': 'No rent due — everything is paid.',
  'Месечен наем': 'Monthly rent',
  'Падеж': 'Due date',
  '{day}-о число': 'day {day} of the month',
  'Автоматично теглене (SEPA)': 'Automatic collection (SEPA)',
  'Подписали сте съгласие — наемът и сметките се теглят сами на падежа. Получавате известие преди всяко теглене и виждате статуса тук.': 'You have signed a mandate — rent and bills are collected automatically on the due date. You get a notification before each collection and can see the status here.',
  'Статус на тегленето': 'Collection status',
  'Отворихме страницата на платежния оператор — там въвеждате име и IBAN и подписвате съгласието. Когато приключите, натиснете бутона.': 'We opened the payment provider page — enter your name and IBAN there and sign the mandate. When you are done, press the button.',
  'Довърших подписването ✓': 'I finished signing ✓',
  'Наемодателят е избрал автоматично теглене. Подписвате еднократно съгласие (мандат) на защитената страница на платежния оператор — там въвеждате IBAN-а си, приложението не го вижда. После наемът се плаща сам всеки месец. Може да прекратите мандата по всяко време.': 'The landlord has chosen automatic collection. You sign a one-time mandate on the payment provider\'s secure page — you enter your IBAN there, the app never sees it. After that the rent is paid automatically every month. You can cancel the mandate at any time.',
  'Подписвам съгласие за теглене': 'Sign the collection mandate',
  'Плащане в брой': 'Cash payment',
  'Отбелязахте „платих в брой“ — чака потвърждение от наемодателя.': 'You marked "paid in cash" — awaiting confirmation from the landlord.',
  'Наемодателят отбеляза, че е получил наема в брой. Потвърждавате ли?': 'The landlord marked the rent as received in cash. Do you confirm?',
  'Потвърждавам ✓': 'I confirm ✓',
  'След като платите на ръка, отбележете тук — наемодателят ще потвърди и ще получите бележка.': 'After you pay in person, mark it here — the landlord will confirm and you will get a receipt.',
  'Платих в брой': 'I paid in cash',
  'Плащане по банка': 'Bank transfer',
  'Копирай IBAN': 'Copy IBAN',
  'Основание': 'Reference',
  'Копирай основанието': 'Copy reference',
  'Въведете този код като основание на превода — така плащането се разпознава автоматично.': 'Enter this code as the transfer reference — that way the payment is matched automatically.',
  'Данните са скрити, докато наемодателят не поднови абонамента си.': 'The details are hidden until the landlord renews their subscription.',
  'Неплатени сметки': 'Unpaid bills',
  'Няма неплатени сметки': 'No unpaid bills',
  'ИТН / клиентски номера': 'Utility / customer numbers',
  'Приемо-предавателен протокол (настаняване)': 'Handover protocol (move-in)',
  'Приемо-предавателен протокол (напускане)': 'Handover protocol (move-out)',
  'Снимките документират състоянието, в което се предава апартаментът. Докоснете снимка за пълен размер и увеличение. С потвърждението приемате имота в този вид (записва се точният час).': 'The photos document the condition in which the apartment is handed over. Tap a photo for full size and zoom. By confirming you accept the property in this condition (the exact time is recorded).',
  'Бележки на наемодателя: {notes}': 'Landlord\'s notes: {notes}',
  'Вашата забележка: „{text}“': 'Your remark: "{text}"',
  'Приета от наемодателя ✓': 'Accepted by the landlord ✓',
  'Чака приемане от наемодателя': 'Awaiting acceptance by the landlord',
  'Забележка по състоянието (по избор)': 'Remark on the condition (optional)',
  'напр. драскотина на паркета в хола, петно на дивана…': 'e.g. scratch on the living room floor, stain on the sofa…',
  'Промени забележката': 'Change remark',
  'Изпрати забележка': 'Send remark',
  'Забележката е изпратена към наемодателя.': 'The remark has been sent to the landlord.',
  'Потвърждавам състоянието ✓': 'I confirm the condition ✓',

  // --- owner/OwnerApartmentsScreen ---
  'Връщане към пропърти мениджърът': 'Return to the property manager',
  'Да възобновим ли управлението към {name}?': 'Resume management with {name}?',
  'Върни': 'Return',
  'Поемате имота сам': 'Taking over the property yourself',
  'Ще управлявате имота сами: профилът ви става наемодателски и започва пробен период на абонамента. Другите ви имоти под чуждо управление си остават непроменени.': 'You will manage the property yourself: your profile becomes a landlord profile and a subscription trial starts. Your other properties under external management remain unchanged.',
  'Поемам го': 'Take it over',
  'Вече сте наемодател на този имот. Отваряме наемодателския изглед…': 'You are now the landlord of this property. Opening the landlord view…',
  'Управлението е възобновено към пропърти мениджърът.': 'Management has been resumed with the property manager.',
  'Моите имоти': 'My properties',
  'Режим само за преглед — имотите се управляват от пропърти мениджъра.': 'View-only mode — the properties are managed by the property manager.',
  'Няма имоти. Когато пропърти мениджър ви покани, те ще се появят тук.': 'No properties. When a property manager invites you, they will appear here.',
  'Замразен (прекратено управление)': 'Frozen (management terminated)',
  'Наемател: {name}': 'Tenant: {name}',
  'чака регистрация': 'awaiting registration',
  'Свободен': 'Vacant',
  'Изберете как да продължите с този имот:': 'Choose how to proceed with this property:',
  'Върни на {name} ({pct}%)': 'Return to {name} ({pct}%)',
  'Поемам го сам': 'Take it over myself',
  'Ако го поемете сам, профилът ви става наемодателски и започва пробен период на абонамента.': 'If you take it over yourself, your profile becomes a landlord profile and a subscription trial starts.',

  // --- owner/OwnerApartmentDetailScreen ---
  'Прекратяване на управлението': 'Terminate management',
  'Имотът ще бъде замразен до прехвърляне. Продължавате ли?': 'The property will be frozen until it is transferred. Continue?',
  'Прекрати': 'Terminate',
  'Управление': 'Management',
  'Пропърти мениджър': 'Property manager',
  'Процент': 'Percentage',
  'От дата': 'Since',
  'Прекрати управлението': 'Terminate management',
  'Прекратено — имотът е замразен': 'Terminated — the property is frozen',
  'Текущ наемател': 'Current tenant',
  'Поканен наемател': 'Invited tenant',
  'Минал наемател': 'Past tenant',
  'Постъпили наеми (вашата сума)': 'Rent received (your share)',
  'Такса превод': 'Transfer fee',
  'Пропърти мениджър ({pct}%)': 'Property manager ({pct}%)',
  'За вас': 'For you',
  'Няма подадени нередности.': 'No issues reported.',
  'Подадена: {date}': 'Reported: {date}',
  'Отстранена: {date}': 'Resolved: {date}',
  'Документи (само преглед)': 'Documents (view only)',
  'Няма документи.': 'No documents.',

  // --- handyman/HandymanRequestsScreen ---
  'Ново запитване': 'New request',
  'Изпратена оферта': 'Offer sent',
  'Приета — за изпълнение': 'Accepted — to be done',
  'Отказана': 'Declined',
  'Завършена ✓': 'Completed ✓',
  'Заявката е приета. Разплащането е по ваша лична уговорка.': 'Request accepted. Payment is by your own arrangement.',
  'Отбелязано като отстранено. Двете страни трябва да потвърдят.': 'Marked as resolved. Both parties must confirm.',
  'Офертата е изпратена.': 'The offer has been sent.',
  'Отбелязано като отстранено. Двете страни трябва да потвърдят, за да се освободи плащането.': 'Marked as resolved. Both parties must confirm for the payment to be released.',
  'Заявки за ремонт': 'Repair requests',
  '⛔ Просрочена фактура за комисионни': '⛔ Overdue commission invoice',
  'Нови заявки и оферти са спрени, докато не платите просрочената фактура по банка. Вижте фактурите по-долу.': 'New requests and offers are paused until you pay the overdue invoice by bank transfer. See the invoices below.',
  'Комисионни към платформата': 'Platform commissions',
  'Натрупани от приети ремонти: {amount} ({n} ремонта) — ще получите фактура.': 'Accrued from accepted repairs: {amount} ({n} repairs) — you will receive an invoice.',
  'падеж {date}': 'due {date}',
  'Платена ✓': 'Paid ✓',
  'ПРОСРОЧЕНА': 'OVERDUE',
  'За плащане': 'To pay',
  '⭐ Доверен майстор сте при:': '⭐ You are a trusted handyman for:',
  'Те могат да ви пращат заявки директно — без оферта и без плащане през приложението.': 'They can send you requests directly — no offer and no payment through the app.',
  'Още нямате запитвания. Наемодателите ви откриват по специалност и район.': 'No requests yet. Landlords find you by trade and area.',
  '⭐ Директна заявка — без плащане през приложението': '⭐ Direct request — no payment through the app',
  'Разплащането е по ваша лична уговорка с наемодателя — извън приложението.': 'Payment is by your own arrangement with the landlord — outside the app.',
  'Приемам заявката': 'Accept request',
  'Отстранено е — качи снимка (задължителна)': 'Fixed — upload a photo (required)',
  'Чака потвърждение от наемодателя и наемателя': 'Awaiting confirmation from the landlord and the tenant',
  'Вашата оферта': 'Your offer',
  'Цена (€)': 'Price (€)',
  'Срок (дни)': 'Time (days)',
  'Съобщение (по избор)': 'Message (optional)',
  'Изпрати оферта': 'Send offer',
  'Задържани {amount} — чакат изпълнение': '{amount} held — awaiting completion',
  'Платено ✓ {amount}': 'Paid ✓ {amount}',
  'Върнато на наемодателя': 'Refunded to the landlord',

  // --- creator/CreatorInvitesScreen ---
  'Линкът за покана е създаден и копиран — изпратете го.': 'The invite link has been created and copied — send it.',
  'Покани': 'Invites',
  'Поканете друг криейтър: генерирайте линк и му го изпратете. Той се регистрира директно от линка в браузъра си, после влиза в приложението с телефон и парола. Линкът е еднократен и с ограничена валидност.': 'Invite another creator: generate a link and send it to them. They register directly from the link in their browser, then log in to the app with phone and password. The link is single-use and expires.',
  '+ Нов линк за покана (копира се)': '+ New invite link (copied)',
  '{used}/{max} използвани': '{used}/{max} used',
  'Изтекла': 'Expired',
  'Активна': 'Active',
  'Копирай линка': 'Copy link',
  'Още нямате покани.': 'No invites yet.',

  // --- creator/CreatorHomeScreen ---
  'Друга': 'Other',
  'Чака преглед': 'Pending review',
  'Одобрена ✓': 'Approved ✓',
  'Видеото е добавено към текущата седмица.': 'The video has been added to the current week.',
  'Седмицата е предадена за преглед.': 'The week has been submitted for review.',
  'Здравейте,': 'Hello,',
  'Профилът чака одобрение': 'Profile pending approval',
  'Ще получите известие, щом бъде прегледан. Дотогава не може да подавате видеа.': 'You will be notified once it is reviewed. Until then you cannot submit videos.',
  'Профилът не е одобрен': 'Profile not approved',
  'Баланс': 'Balance',
  '{reward} € на одобрена седмица · теглене от {min} €': '{reward} € per approved week · withdraw from {min} €',
  '💡 Идеи за видеа': '💡 Video ideas',
  'Актуални промоции и теми — видеата по тях се броят като всички останали.': 'Current promotions and topics — videos on them count like any other.',
  'Условия за седмицата': 'Weekly requirements',
  '• Поне {n} видеа, публикувани в поне {m} различни мрежи': '• At least {n} videos, published on at least {m} different networks',
  '• Поне {n} гледания на видео': '• At least {n} views per video',
  '• При повече видеа — общо поне {n} гледания за седмицата': '• With more videos — at least {n} views in total for the week',
  '• Прегледът е ръчен — подавайте линк към всяко видео': '• Review is manual — submit a link to each video',
  'Пълни условия за участие →': 'Full terms of participation →',
  'Текуща седмица': 'Current week',
  'Още няма видеа тази седмица.': 'No videos this week yet.',
  'Линк към видеото': 'Video link',
  'Платформа': 'Platform',
  'Изберете платформа…': 'Select a platform…',
  'Бележка (по избор)': 'Note (optional)',
  'напр. колаборация с...': 'e.g. collaboration with...',
  '+ Добави видео': '+ Add video',
  '{n} видео(а) · {m} мрежи. Може да предадете сега или седмицата ще се предаде сама в края си.': '{n} video(s) · {m} networks. You can submit now or the week will be submitted automatically at its end.',
  'Предай седмицата за преглед': 'Submit the week for review',
  'Предадена — чака преглед': 'Submitted — pending review',
  'История': 'History',
  'Още няма минали седмици.': 'No past weeks yet.',
  '{n} видео(а)': '{n} video(s)',
  '+ {amount} в баланса': '+ {amount} to balance',
  'Предай за преглед': 'Submit for review',

  // --- creator/CreatorMoneyScreen ---
  'Чака превод': 'Awaiting transfer',
  'Изплатено ✓': 'Paid out ✓',
  'Отказано': 'Rejected',
  'Данните за фактура са запазени.': 'Invoice details saved.',
  'Документите са изпратени. Администратор ще ги прегледа.': 'The documents have been sent. An administrator will review them.',
  'Заявката е изпратена. Преводът се прави ръчно по банка.': 'The request has been sent. The transfer is made manually by bank.',
  'Пари': 'Money',
  'Наличен баланс · минимум за теглене {min} €': 'Available balance · minimum withdrawal {min} €',
  'Данни за фактура': 'Invoice details',
  'За услугата „създаване на видео съдържание" ти издаваш фактура на платформата. Попълни данните — те са задължителни преди верификация и теглене.': 'For the service "video content creation" you issue an invoice to the platform. Fill in the details — they are required before verification and withdrawal.',
  '⚠️ Още не са попълнени.': '⚠️ Not filled in yet.',
  'Тип': 'Type',
  'Физическо лице': 'Individual',
  'Фирма': 'Company',
  'Име на фирмата': 'Company name',
  'Име и фамилия': 'First and last name',
  'Крео ЕООД': 'Creo Ltd.',
  'Иван Иванов': 'John Smith',
  'ЕГН': 'Personal ID number (EGN)',
  'ЕГН се пази криптирано и се вижда само от администратора във фактурата.': 'The personal ID number is stored encrypted and is visible only to the administrator on the invoice.',
  'ЕИК': 'Company ID (EIK)',
  'МОЛ': 'Accountable person (MOL)',
  'ДДС № (по избор)': 'VAT No. (optional)',
  'Град': 'City',
  'София': 'Sofia',
  'Адрес': 'Address',
  'ул. …, №': 'Street …, No.',
  'Запази промените': 'Save changes',
  'Запази данните за фактура': 'Save invoice details',
  'Верификация': 'Verification',
  'Верифициран с лична карта ✓': 'Verified with ID card ✓',
  'Документите чакат преглед': 'Documents pending review',
  'Администратор ще ги провери. Ще получите известие.': 'An administrator will check them. You will be notified.',
  'Първо попълнете данните за фактура по-горе — те са задължителни за верификацията.': 'First fill in the invoice details above — they are required for verification.',
  'Преди първото теглене е нужна еднократна верификация: снимка на личната карта + селфи. Документите са криптирани, вижда ги само администраторът и се изтриват след проверката (GDPR).': 'Before the first withdrawal a one-time verification is required: a photo of your ID card + a selfie. The documents are encrypted, visible only to the administrator and deleted after the check (GDPR).',
  '✓ Лична карта — сменена': '✓ ID card — changed',
  '1. Снимка на личната карта': '1. Photo of ID card',
  '✓ Селфи — сменено': '✓ Selfie — changed',
  '2. Селфи': '2. Selfie',
  'Изпрати за проверка': 'Send for verification',
  'Теглене': 'Withdrawal',
  'Тегленето се отключва при {min} € натрупани. Остават {left}.': 'Withdrawal unlocks at {min} € accrued. {left} to go.',
  'Балансът стига, но първо завършете верификацията с лична карта по-горе.': 'Your balance is sufficient, but first complete the ID card verification above.',
  'Сума (€)': 'Amount (€)',
  'Преводът се прави ръчно по банка от администратора — обикновено до няколко работни дни.': 'The transfer is made manually by bank by the administrator — usually within a few working days.',
  'Заяви теглене': 'Request withdrawal',
  'Тегления': 'Withdrawals',
  'Моите фактури': 'My invoices',
  'История на баланса': 'Balance history',
  'Одобрена седмица': 'Approved week',
  'Изплатено теглене': 'Withdrawal paid',
  'Корекция': 'Adjustment',

  // --- resident/ResidentHomeScreen ---
  'Още не сте добавени към имот. Когато наемодателят ви добави като обитател, адресът ще се появи тук.': 'You have not been added to a property yet. When the landlord adds you as a resident, the address will appear here.',
  'Управлява: {name}': 'Managed by: {name}',
  'Съобщи проблем': 'Report a problem',
  'Нямате подадени нередности.': 'You have not reported any issues.',
  'Въведете телефонния номер на кандидата. Безплатно, без регистрация.': 'Enter the candidate\'s phone number. Free, no registration.',
  '▾ Пример как изглежда резултат': '▾ Example of what a result looks like',
  '▸ Пример как изглежда резултат': '▸ Example of what a result looks like',
};
